(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gocurrent-service-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gcsp').forEach((section) => {
    const radios = section.querySelectorAll('[data-gcsp-variant]');
    const price = section.querySelector('[data-gcsp-price]');
    const stickyPrice = section.querySelector('[data-gcsp-sticky-price]');
    const stickySubmit = section.querySelector('[data-gcsp-submit]');
    const form = section.querySelector('.gcsp__form');

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        price.textContent = radio.dataset.price;
        stickyPrice.textContent = radio.dataset.price;
      });
    });

    stickySubmit?.addEventListener('click', () => form?.requestSubmit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
